import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import HomePage from "./pages/homepage";
import ProjectsPage from "./pages/projectspage"; // Create this component for Projects
import AdminApp from "./admin/AdminApp";
import { RefsProvider } from "./context/refscontext";
import { DrawerProvider } from "./context/drawercontext";
import ContactDrawer from "./components/contactdrawer";
import { ProjectsProvider } from "./context/ProjectsContext";

function App() {
  return (
    <ProjectsProvider>
      <DrawerProvider>
        <RefsProvider>
          <Router>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/projects/:projectType" element={<ProjectsPage />} />
              <Route path="*" element={<HomePage />} />
              <Route path="/admin/*" element={<AdminApp />} />
            </Routes>
            <ContactDrawer />
          </Router>
        </RefsProvider>
      </DrawerProvider>
    </ProjectsProvider>
  );
}

export default App;
